module.exports = __webpack_public_path__ + "img/book_liucheng.0545339e.png";